import Reactotron from 'reactotron-react-js'
Reactotron
    .configure() // we can use plugins here -- more on this later
    .connect() // let's connect!